import { Phone, MapPin, Clock, Instagram } from "lucide-react";
import { CONTACT } from "@/data/content";

const LINKS = [
  { href: "#hizmetler", label: "Hizmetler" },
  { href: "#neden-biz", label: "Neden Biz" },
  { href: "#yorumlar", label: "Yorumlar" },
  { href: "#galeri", label: "Galeri" },
  { href: "#iletisim", label: "İletişim" },
];

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo-icon.png" alt="Sistemli Otomotiv logosu" className="h-10 w-10" />
            <span className="font-display text-lg font-extrabold tracking-tight text-white">
              SİSTEMLİ <span className="text-blue-400">OTOMOTİV</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            Adana Seyhan'da kaporta, fırınlı boya, mekanik ve elektrik servisleri; 1.026 m² kapalı
            atölyede tek çatı altında.
          </p>
        </div>

        <div>
          <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Sayfalar</p>
          <ul className="mt-4 flex flex-col gap-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  className="text-sm text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-display text-sm font-bold uppercase tracking-wider text-white">
            İletişim
          </p>
          <ul className="mt-4 flex flex-col gap-3 text-sm">
            <li>
              <a
                href={CONTACT.phoneHref}
                data-testid="footer-phone-link"
                className="inline-flex items-center gap-2.5 text-slate-400 transition-colors hover:text-white"
              >
                <Phone className="h-4 w-4 text-blue-400" />
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2.5 text-slate-400 transition-colors hover:text-white"
              >
                <Instagram className="h-4 w-4 text-pink-400" />
                {CONTACT.instagramHandle}
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <span className="text-slate-400">{CONTACT.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Clock className="h-4 w-4 text-blue-400" />
              <span className="text-slate-400">Pzt–Cmt 08:00–19:00 • Pazar kapalı</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-slate-800 pt-6 text-center">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © {new Date().getFullYear()} Sistemli Otomotiv. Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
